{
  "name": "@ns/public-ledger-auto-payments-stop",
  "version": "1.0.0",
  "description": "Stop the company's automatic payments (#40). Held by the signatory who started it (from My Account); any public ledger signatory can claim it if it is released. The card says what stopping means; the holder proposes the stop (public-ledger/autopay/propose-stop), which completes the card proposed. Every signatory then signs an allowance of 0 on the public ledger, paid by nodeStream's platform account, and automatic payments stop once it has run. cancel ends it with nothing signed.",
  "inputs": {},
  "outcomes": {
    "proposed": {
      "serverOnly": true
    },
    "cancel": {}
  }
}
